import {
  parseBodyMapFromData,
  parseContentMapFromData,
  parseMaterialMapFromData,
} from "../../utilization/CatchtivityUtilization";
import ActivityBodyContent from "./body-contents/ActivityBodyContent";
import MCMAActivityMaterialContent from "./material-contents/MCMAActivityMaterialContent";
import { IMCMAActivityProps } from "../../properties/ActivityProperties";
import ActivitySolveLayout from "./ActivitySolveLayout";

const MCMAActivityContent = ({
  answerMap,
  data,
  canAnswerQuestion,
  changeAnswer,
  isPreview,
  showCorrectAnswer,
  isFullScreen,
  passage,
}: IMCMAActivityProps) => {
  const contentMap = parseContentMapFromData(data);
  const MCMABodyMap = parseBodyMapFromData(data, "MCMA");
  const MCMAMaterialMap = parseMaterialMapFromData(data, "MCMA");

  const handleMCMAAnswerOnChange = (
    answerMap: any,
    key: any,
    value: string
  ) => {
    if (isPreview) return;
    const foundSubIndex = answerMap[key].findIndex(
      (answerMaterialKey: string) => answerMaterialKey === value
    );
    if (foundSubIndex === -1) {
      answerMap[key].push(value);
    } else {
      answerMap[key].splice(foundSubIndex, 1);
    }
    changeAnswer(answerMap);
  };

  return (
    <ActivitySolveLayout
      variant="split"
      // Safe to pin: ticking options never changes the pane's height.
      paneFit
      isFullScreen={isFullScreen}
      passage={passage}
      body={<ActivityBodyContent bodyMap={MCMABodyMap} templateType={"MCMA"} />}
      interaction={
        <MCMAActivityMaterialContent
          uniqueValue={JSON.stringify(data.contentMap)}
          answerMap={answerMap}
          materialMap={MCMAMaterialMap}
          contentMap={contentMap}
          checkCanAnswerQuestion={canAnswerQuestion}
          onChange={handleMCMAAnswerOnChange}
          isPreview={isPreview}
          showCorrectAnswer={showCorrectAnswer}
        />
      }
    />
  );
};

export default MCMAActivityContent;
